import type { SocialLink } from '../types';

export const socialPlatformMeta: Record<string, { icon: string; title: string }> = {
  facebook: { icon: 'bi-facebook', title: 'Facebook' },
  twitter: { icon: 'bi-twitter-x', title: 'Twitter / X' },
  instagram: { icon: 'bi-instagram', title: 'Instagram' },
  tiktok: { icon: 'bi-tiktok', title: 'TikTok' },
  youtube: { icon: 'bi-youtube', title: 'YouTube' },
  linkedin: { icon: 'bi-linkedin', title: 'LinkedIn' },
  custom: { icon: 'bi-link-45deg', title: 'Link' },
};

export function parseSocialLinksJson(json?: string | null): SocialLink[] {
  if (!json) return [];
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((l): l is SocialLink => {
      if (!l || typeof l !== 'object') return false;
      const maybeLink = l as Partial<SocialLink>;
      return typeof maybeLink.url === 'string' && maybeLink.url.trim().length > 0;
    });
  } catch {
    return [];
  }
}
